// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__13B0H","signatureBlock":"Footer_signatureBlock__3P9v0","signature":"Footer_signature__Vrms0"};